import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Vehicles from './components/Vehicles';
import Contact from './components/Contact';
import Careers from './components/Careers';
import Footer from './components/Footer';
import ScrollToSection from './components/ScrollToSection';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage';

function HomePage() {
  useEffect(() => {
    document.title = 'InTimelog | On-Time Crew & Transportation Services in Dallas, TX';
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ScrollToSection />
      <main>
        <Hero />
        <About />
        <Vehicles />
        <Contact />
        <Careers />
      </main>
    </>
  );
}

function AppContent() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<HomePage />} />
        <Route path="/vehicles" element={<HomePage />} />
        <Route path="/contact" element={<HomePage />} />
        <Route path="/careers" element={<HomePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;